import { updateObject } from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import {
  createFileAudioDataInitialState,
  currentFileAudioInitialState,
} from "./helper";

const initialState = {
  fileAudioData: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  exportLoading: false,
  downloadFileAudioLoading: false,
  createFileAudioData: createFileAudioDataInitialState,
  createFileAudioLoading: false,
  currentFileAudio: currentFileAudioInitialState,
};

const setGestioneFileAudioData = (state, action) => {
  return updateObject(state, {
    fileAudioData: updateObject(state.fileAudioData, {
      [action.key]: action.value,
    }),
  });
};

const setFileAudioExportLoading = (state, action) => {
  return updateObject(state, {
    exportLoading: action.value,
  });
};

const setDownloadFileAudioLoading = (state, action) => {
  return updateObject(state, {
    downloadFileAudioLoading: action.value,
  });
};

const setCreateFileAudioData = (state, action) => {
  return updateObject(state, {
    createFileAudioData: updateObject(state.createFileAudioData, {
      [action.key]: action.value,
    }),
  });
};

const setCreateFileAudioLoading = (state, action) => {
  return updateObject(state, {
    createFileAudioLoading: action.value,
  });
};

const setCurrentFileAudio = (state, action) => {
  return updateObject(state, {
    currentFileAudio: updateObject(state.currentFileAudio, {
      [action.key]: action.value,
    }),
  });
};

const fileAudioReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_GESTIONE_FILE_AUDIO_DATA:
      return setGestioneFileAudioData(state, action);
    case actionTypes.EXPORT_FILE_AUDIO_LOADING:
      return setFileAudioExportLoading(state, action);
    case actionTypes.DOWNLOAD_FILE_AUDIO_LOADING:
      return setDownloadFileAudioLoading(state, action);
    case actionTypes.GET_CREATE_FILE_AUDIO_DATA:
      return setCreateFileAudioData(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_FILE_AUDIO:
      return setCreateFileAudioLoading(state, action);
    case actionTypes.GET_CURRENT_FILE_AUDIO:
      return setCurrentFileAudio(state, action);
    default:
      return state;
  }
};

export default fileAudioReducer;
